module.exports = __webpack_public_path__ + "img/lerner-features-banner.4bf40c06.svg";